

























































































import { faUser } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '@nuxtjs/composition-api'
import { mapState, mapActions } from 'vuex'
import { format } from '~/utils/date'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { toCamelCase, toCamel } from '~/utils/object'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { ciBodyChassis } from '~/icons/source/regular/body-chassis'
import { ciInterior } from '~/icons/source/regular/interior'
import { ciTransmission } from '~/icons/source/regular/transmission'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { ciCarState } from '~/icons/source/regular/car-state'
import { ciCarStateBad } from '~/icons/source/regular/car-state-bad'
import { ciCarStateGood } from '~/icons/source/regular/car-state-good'
import {
  ExternalCertificates,
  ExternalCertificatesAuditCategory
} from '~/models/external-certificates/types'
import { ciEngine } from '~/icons/source/regular/engine'

export default defineComponent({
  components: {
    CCard,
    ExternalCertificatesReport: () =>
      import(
        '~/components/car/classifieds/view/partials/ExternalCertificates/ExternalCertificatesReport.vue'
      ),
    CAvatar
  },

  data() {
    return {
      isModalVisible: false,
      selectedAuditCategory: null,
      isReportVisible: false
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => toCamelCase(state.classified)
    }),
    externalCertificates(): ExternalCertificates {
      if (this.classified.externalCertificates) {
        return this.classified.externalCertificates
      }
      return null
    },
    auditCategoriesCounts() {
      if (this.externalCertificates?.auditCategoriesCounts) {
        return this.classified.externalCertificates.auditCategoriesCounts.map(
          c => ({
            ...c,
            name: toCamel(c.name)
          })
        )
      }

      return null
    },
    auditCategories() {
      if (this.externalCertificates?.auditCategories) {
        return this.classified.externalCertificates.auditCategories
      }

      return null
    },
    generalInfo() {
      if (this.externalCertificates?.generalInfo) {
        return this.externalCertificates.generalInfo
      }

      return null
    },
    fourSpots() {
      return [
        {
          value: this.$t('body chassis'),
          label: 'body chassis',
          status: this.getSpotByName('body_chassis'),
          name: 'body_chassis',
          icon: ciBodyChassis
        },
        {
          value: this.$t('engine'),
          label: 'engine',
          status: this.getSpotByName('engine'),
          name: 'engine',
          icon: ciEngine
        },
        {
          value: this.$t('motion transmission'),
          label: 'motion transmission',
          status: this.getSpotByName('motion_transmission'),
          name: 'motion_transmission',
          icon: ciTransmission
        },
        {
          value: this.$t('interior'),
          label: 'interior',
          status: this.getSpotByName('interior'),
          name: 'interior',
          icon: ciInterior
        }
      ].filter(s => s.status !== undefined)
    },
    icons() {
      return {
        user: faUser,
        moderate: ciCarState,
        bad: ciCarStateBad,
        good: ciCarStateGood
      }
    },
    checkedDate() {
      if (this.generalInfo?.date) {
        return format(this.generalInfo.date.value, 'dd/MM/yyyy')
      }
      return ''
    },
    make() {
      return this.generalInfo?.make?.value
    },
    model() {
      return this.generalInfo?.model?.value
    },
    exteriorColor() {
      return this.generalInfo?.exteriorColor?.value
    },
    generalComments() {
      return this.externalCertificates?.generalComments?.trim()
    },
    year() {
      const year = this.classified?.titleParts?.year

      return year ? `'${year.toString()?.substring(2, 4)}` : null
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      fetchExternalCertificates: 'fetchExternalCertificates'
    }),
    handleCertificateItemClick(cat: ExternalCertificatesAuditCategory) {
      if (!this.externalCertificates.auditCategories?.length) {
        this.fetchExternalCertificates()
      }
      if (cat) {
        this.$analytics.recordEvent({
          namespace: 'n_external_certificates_category',
          action: 'click',
          label: cat.label
        })
      }
      this.isModalVisible = true
      this.selectedAuditCategory = cat
    },
    handleModalClose() {
      this.isModalVisible = false
      this.isReportVisible = false
    },
    handleModalShown() {
      this.isReportVisible = true
    },

    getSpotByName(spot: string) {
      return this.externalCertificates.auditCategoriesCounts.find(
        c => c.name === spot
      )?.state
    }
  }
})
